import { useMemo } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LOAN_PAYMENT_FREQUENCIES } from "web_myplann/Portfolio/Helpers/loanPaymentFrequencies";

export const useLoanPaymentFrequencyOptions = () => {
	const { t } = useResource();

	return useMemo(
		() =>
			LOAN_PAYMENT_FREQUENCIES.map((frequency) => ({
				value: frequency,
				label: t(Resources.PortfolioDetail.SharedLabels.Frequency[frequency]),
			})),
		[t],
	);
};
